
import { defineComponent, PropType } from 'vue'

type AlertTypes = 'info' | 'warning' | 'danger' | 'neutral'

export default defineComponent({
  name: 'ZAlert',
  props: {
    type: {
      type: String as PropType<AlertTypes>,
      required: true,
      validator: (value: string) => ['info', 'warning', 'danger', 'neutral'].includes(value)
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: true,
      textContainerHeight: 0,
      colors: {
        info: 'robin',
        warning: 'honey',
        danger: 'cherry',
        neutral: 'vanilla-100'
      },
      observer: {} as ResizeObserver
    }
  },
  computed: {
    bgColor(): string {
      const bgColors: Record<AlertTypes, string> = {
        info: 'bg-robin',
        warning: 'bg-honey',
        danger: 'bg-cherry',
        neutral: 'bg-ink-300'
      }
      return bgColors[this.type]
    },
    textColor(): string {
      const textColors: Record<AlertTypes, string> = {
        info: 'text-robin-400',
        warning: 'text-honey-400',
        danger: 'text-cherry-400',
        neutral: 'text-vanilla-100'
      }
      return textColors[this.type]
    }
  },
  /**
   * Mounted hook for Vue component
   */
  mounted() {
    // Initialize the observer on mount
    this.$nextTick(() => {
      this.initObserver()
    })
  },
  /**
   * BeforeDestroy hook for Vue component
   */
  beforeDestroy() {
    // Unobserve before destroy
    if (this.observer?.unobserve && this.$refs['text-container']) {
      this.observer.unobserve(this.$refs['text-container'] as Element)
    }
  },
  methods: {
    /**
     * Callback function passed to ResizeObserver constructor
     */
    onResize() {
      if (this.$refs['text-container']) {
        this.textContainerHeight = (this.$refs['text-container'] as HTMLElement).offsetHeight
      }
    },

    /**
     * Initialize observer
     */
    initObserver() {
      const element = this.$refs['text-container']
      if (element) {
        const observer = new ResizeObserver(this.onResize)
        observer.observe(element as Element)
        this.observer = observer
      }
    },

    /**
     * Hide Alert
     */
    hideAlert() {
      this.isVisible = false
      this.$emit('dismiss')
    }
  }
})
